import { Row, Col, Form } from "react-bootstrap";
const EditForm = () => {
  return (
    <div className="account-settingside safartabs card">
      <div className="p-4 card-body">
        <div className="form-inputssetting">
          <Form onSubmit="">
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="name">Logo</Form.Label>
                  <Form.Control
                    type="file"
                    id="file"
                    name="file"
                    value=""
                    onChange=""
                    placeholder="Enter Name"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="mobile_no">Business Name</Form.Label>
                  <Form.Control
                    id="Business_name"
                    name="Business_name"
                    value=""
                    onChange=""
                    placeholder="Developer"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="mobile_no">Business Name</Form.Label>
                  <Form.Control
                    id="Business_name"
                    name="Business_name"
                    value=""
                    onChange=""
                    placeholder="Developer"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="user_handle">Address</Form.Label>
                  <Form.Control
                    id="address"
                    name="address"
                    value=""
                    onChange=""
                    placeholder="c-51"
                    isInvalid=""
                  />
                  {/* <div className="form-text text-muted">
                    <i>Allowed Character: az09_-</i>
                  </div> */}
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="date_of_birth">D.O.B.</Form.Label>
                  <Form.Control
                    type="date"
                    id="date_of_birth"
                    name="date_of_birth"
                    value=""
                    onChange=""
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="user_bio">About Business</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    id="user_bio"
                    name="user_bio"
                    value=""
                    onChange=""
                    placeholder="Tr"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="website_url">website</Form.Label>
                  <Form.Control
                    id={"website_url"}
                    name={"website_url"}
                    value=""
                    onChange=""
                    placeholder="This wesite will be visible to clients"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="name">Phone No</Form.Label>
                  <Form.Control
                    id="number"
                    name="number"
                    value=""
                    onChange=""
                    placeholder="Enter Name"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="name">Operator Phone No</Form.Label>
                  <Form.Control
                    id="number"
                    name="number"
                    value=""
                    onChange=""
                    placeholder="Enter Name"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="name">Email</Form.Label>
                  <Form.Control
                    id="email"
                    name="email"
                    value=""
                    onChange=""
                    placeholder="sandeep@triline.co.in"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="name">Operator Email</Form.Label>
                  <Form.Control
                    id="email"
                    name="email"
                    value=""
                    onChange=""
                    placeholder="sandeep@triline.co.in"
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="insta_url">Instagram Url</Form.Label>
                  <Form.Control
                    id={"insta_url"}
                    name={"insta_url"}
                    value=""
                    onChange=""
                    placeholder={`Instagram profile Link`}
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="facebook_url">Facebook Url</Form.Label>
                  <Form.Control
                    id={"facebook_url"}
                    name={"facebook_url"}
                    value=""
                    onChange=""
                    placeholder={`Facebook profile Link`}
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="youtube_url">Youtube Link</Form.Label>
                  <Form.Control
                    id={"youtube_url"}
                    name={"youtube_url"}
                    value=""
                    onChange=""
                    placeholder={`Youtube profile Link`}
                    isInvalid=""
                  />
                  <Form.Control.Feedback type="invalid">
                    {}
                  </Form.Control.Feedback>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="youtube_url">
                    Has Cancellation Policy
                  </Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option>select</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </Form.Select>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Form.Label htmlFor="youtube_url">
                    Has Cancellation Policy
                  </Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
               
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <Form.Label htmlFor="youtube_url">
                  Budget Segment
                  </Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Check aria-label="option 1" />
                    <Form.Label htmlFor="youtube_url" className="fw-normal">
                      Has Cancellation Policy
                    </Form.Label>
                  </div>
               
                </div>
              </Col>



              <Col md={12}>
                <div className="float-end">
                  <button type="submit" className="search_submit_btn post-comment" disabled="">
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EditForm;
